
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class HoldingClassWeightDialog extends SiteEntityDialog<HoldingClassWeightRow, any> {
        protected getFormKey() { return HoldingClassWeightForm.formKey; }
        protected getIdProperty() { return HoldingClassWeightRow.idProperty; }
        protected getLocalTextPrefix() { return HoldingClassWeightRow.localTextPrefix; }
        protected getNameProperty() { return HoldingClassWeightRow.nameProperty; }
        protected getService() { return HoldingClassWeightService.baseUrl; }

        protected form = new HoldingClassWeightForm(this.idPrefix);

    }
}